import React from 'react'
import MainForm from './MainForm'

const Main = (props) => (
  <MainForm {...props} />
)

export default Main